import request from '@/util/axios';

export const getWxCode = (deptCode,floorCode,deptName,floorName) => {
  return request({
    url: '/rentbed/wx/getWxaCode',
    method: 'get',
    params: {deptCode,floorCode,deptName,floorName},
    responseType:'blob',
  })
}


export const groupByDept2 = () => {
  return request({
    url: '/rentbed/sys/sysDepfloor/groupByDept2',
    method: 'post',
  })
}

export const refund = (orderNo,rentDay,type) => {
  return request({
    url: '/rentbed/wx/refund/'+orderNo+"/"+rentDay+"/"+type,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/wx/wx.js